module.exports = __webpack_public_path__ + "static/img/1082.7997733.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1082.jpg
// module id = 264
// module chunks = 0